import { Module, ModuleType } from './Module';
import { LearningObjective } from './LearningObjective';
import { Organisation } from './Organisation';
import { UserModel } from './User';
import { ModuleItem } from 'pages/build-course/components/generateContentComponents/ModuleItem';

export type Course = {
    id: string;
    title: string;
    description: string;
    modules: Module[];
    dateCreated: string;
    dateUpdated: string;
    category: string;
    learningObjectives: LearningObjective[];
    published: boolean;
    userId: string;
    organisation: Organisation;
    user?: UserModel;
    dateGenerateStart?: Date;
    dateGenerateEnd?: Date;
    dateGenerateError?: Date;
};

type CourseGenerateStatus = 'none' | 'generating' | 'complete' | 'error';
export function getCourseGenerateStatus(course: Course): CourseGenerateStatus {
    if (!!course.dateGenerateError) {
        return 'error';
    } else if (!!course.dateGenerateEnd) {
        return 'complete';
    } else if (!!course.dateGenerateStart) {
        return 'generating';
    } else {
        return 'none';
    }
}

export type PublishedCourse = Course & {
    courseSchedulesCount: number;
    organisationNumberOfLiveCourses: number;
    courseIsFree: boolean;
};

export function CourseGeneratedContentIsApproved(moduleItems: ModuleItem[]): boolean {
    const generateItems = moduleItems.flatMap((mi) => mi.generateItems);
    if (generateItems.length === 0) return false;
    return generateItems.every((status) => status.status === 'APPROVED');
}

export function CourseIsReadyToPublish(course: Course, moduleItems: ModuleItem[]): boolean {
    const courseTitleComplete = !!course.title;
    const learningObjectivesComplete = course.learningObjectives.length >= 1;
    const modulesAndActivitiesComplete =
        course.modules.length >= 1 && course.modules.every((m) => m.activities.length >= 1);
    const generatedContentComplete =
        course.modules.every((m) => m.moduleType === ModuleType.PRESENTATION) ||
        CourseGeneratedContentIsApproved(moduleItems);

    const courseReadyToPublish =
        courseTitleComplete && learningObjectivesComplete && modulesAndActivitiesComplete && generatedContentComplete;

    return courseReadyToPublish;
}
